import { MongoObservable } from "meteor-rxjs";
import { Log } from "../models";
import { LogMessages } from "./logmessages";

export const Logs = new MongoObservable.Collection<Log>("logs", { connection: null });

// Dispose unused  log messages
Logs.collection.after.remove(function(userId, doc) {
  LogMessages.collection.remove({ logId: doc._id });
});
Meteor.startup(() => {
if (Meteor.isServer) {
  Logs.collection._ensureIndex({assignedActivityUserIds: 1});
  Logs.collection._ensureIndex({additionalUserIds: 1});
  Logs.collection._ensureIndex({p6ActivityId: 1});
  Logs.collection._ensureIndex({projectId: 1});
  Logs.collection._ensureIndex({creatorId: 1});
}
});



// WEBPACK FOOTER //
// ./src/api/server/collections/logs.ts